import { Component, Input, OnInit } from '@angular/core';
import { SummaryData } from 'src/app/pages/new-service/interfaces/SummaryData';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
})
export class ContactInfoComponent implements OnInit {
  @Input() summaryData: SummaryData = {} as SummaryData;
  @Input() hideIsParticular: boolean = false;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
  }

  isSameContact(): boolean {
    const li = this.summaryData.locationInfo;
    if (!li) return false;

    return (
      !!li.originContactName &&
      !!li.destinationContactName &&
      li.originContactName === li.destinationContactName &&
      li.originContactLastName === li.destinationContactLastName &&
      li.originContactPhoneNumber === li.destinationContactPhoneNumber
    );
  }

  handleIsExternal(value?: boolean): string {
    return value
      ? this.translate.instant('external_contact')
      : this.translate.instant('internal_contact');
  }
}
